import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, or } from 'firebase/firestore';
import { db } from '../firebase';
import { Event, UserData } from './Create';
import { doc, setDoc, deleteDoc } from 'firebase/firestore'

export interface User {
  uid: string;
  email: string;
  displayName: string;
}
export default function Dashboard() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [events, setEvents] = useState<Event[]>([]);

  useEffect(() => {
    get_my_events();
  }, [currentUser]);

  async function get_my_events() {
    if (!currentUser) {
      alert("No current user");
      return;
    }
    const eventsSnapshot = await getDocs(collection(db, 'events'));
    const my_events_list: Event[] = [];
    eventsSnapshot.forEach((doc) => {
      const eventData = doc.data() as Event;
      if (eventData.members.some(member => member.uid === currentUser.uid)) {
        my_events_list.push(eventData);
      }
    });

    setEvents(my_events_list);
  }

  async function handleLogout() {
    try {
      await logout();
      navigate('/login');
    } catch (err) {
      console.error('Failed to log out', err);
    }
  }

  function Get_secret_santa({ currentUserIndex, event }: { currentUserIndex: number, event: Event }) {
    if (event.members[currentUserIndex].secretsanta === undefined) {
      alert("Yo, this should never happen")
      return
    } else {
      var secret_santa = event.members[currentUserIndex].secretsanta
      return secret_santa
    }

  }
  function shuffleArray(array: UserData[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  function create_acceptable_ss_list({ joinedMembers }: { joinedMembers: UserData[] }) {
    const newArray = [...joinedMembers]
    let matchesExist = true;
    while (matchesExist) {
      shuffleArray(newArray);
      matchesExist = false;
      for (let i = 0; i < newArray.length; i++) {
        if (newArray[i] === joinedMembers[i]) {
          matchesExist = true;
          break; // A match found, break the inner loop and shuffle again
        }
      }
    }
    return newArray;
  }

  function Delete_Button({ event }: { event: Event }) {
    async function delete_event() {
      if (!event.uid) {
        alert("This event has an invalid ID.");
        return;
      }

      const confirmDelete = window.confirm(
        `Are you sure you want to permanently delete "${event.name}"? This cannot be undone.`
      );

      if (!confirmDelete) {
        return;
      }

      try {
        // Delete from Firestore
        await deleteDoc(doc(db, 'events', event.uid));

        // Remove from local state
        setEvents(prevEvents => prevEvents.filter(e => e.uid !== event.uid));

        alert("Event deleted successfully!");
      } catch (error) {
        console.error("Error deleting event:", error);
        alert("Failed to delete event. Please try again.");
      }
    }
    return (
      <button
        onClick={() => delete_event()}
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: '#C71212',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          margin: '10px'
        }}>
        Permanently Delete Event
      </button>
    )
  }

  function Secret_santa_button_display({ event }: { event: Event }) {

    async function pick_secret_santa() {
      var joinedMembers = event.members.filter((member) => member.joined === true)
      if (joinedMembers.length < 2) {
        alert('Yo, you must have more people join')
        return
      }
      if (!event.uid) {
        alert(`The event '${event.name}' has an invalid ID. Please contact support.`);
        return;
      }
      var acceptable_ss_list = create_acceptable_ss_list({ joinedMembers })

      var new_event = {
        ...event,
        picked: true,
        members: joinedMembers.map((member, memberIndex) => ({
          ...member,
          secretsanta: acceptable_ss_list[memberIndex].displayName ?? undefined
        }))
      }
      setEvents(prevEvents =>
        prevEvents.map((e) =>
          e === event ? new_event : e
        )
      );

      await setDoc(doc(db, 'events', event.uid), new_event);
    }
    return (
      <button
        onClick={() => pick_secret_santa()}
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: '#109433',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          margin: '10px'
        }}>
        Pick Secret Santa
      </button>
    )
  }

  function Buttons_for_members_while_event_is_not_picked({ event, currentUserIndex }: { event: Event, currentUserIndex: number }) {
    async function toggle_joined() {
      if (!event.uid) {
        alert(`The event '${event.name}' has an invalid ID. Please contact hugo.b.collins@gmail.com`);
        return;
      }
      var updated_event = {
        ...event,
        members: event.members.map((member, idx) =>
          idx === currentUserIndex
            ? { ...member, joined: !member.joined }
            : member
        )
      }
      setEvents(prevEvents =>
        prevEvents.map((e) => e === event ? updated_event : e)
      );
      await setDoc(doc(db, 'events', event.uid), updated_event);
    }

    async function leave_event() {
      if (!event.uid) {
        alert(`The event '${event.name}' has an invalid ID. Please contact hugo.b.collins@gmail.com`);
        return;
      }
      const confirmDelete = window.confirm(
        `Are you sure you want to permanently leave "${event.name}"? This cannot be undone.`
      );
      if (!confirmDelete) {
        return;
      }
      var new_event = {
        ...event,
        members: event.members.filter((member) => (member.uid !== currentUser?.uid))
      }
      setEvents(prevEvents =>
        prevEvents.map((e) =>
          e === event ? new_event : e
        )
      );

      await setDoc(doc(db, 'events', event.uid), new_event);
    }

    return (
      <>
        <button
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#109433',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            margin: '10px'
          }}
          onClick={() => toggle_joined()}
        >
          {event.members[currentUserIndex].joined ? "Leave Event" : "Join Event"}
        </button>
        <button
          onClick={() => leave_event()}
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#C71212',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            margin: '10px'
          }}
        >
          Permanently Dismiss Event
        </button>
      </>
    )
  }

  function Event_Display({ event }: { event: Event }) {
    var currentUserIndex = event.members.findIndex(user => user.uid === currentUser?.uid)
    if (currentUserIndex === -1) {
      return <div>You are no longer a member of {event.name}</div>;
    }
    var secret_santa_name = event.picked
      ? Get_secret_santa({ currentUserIndex, event })
      : null;

    return (
      <div>
        <h4>{event.name}, Owned by {(event.owner?.uid === currentUser?.uid) ? "You" : event.owner?.displayName}</h4>
        <ul>
          {event.members.map((member, memberIndex) => (
            <li key={memberIndex} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '5px'
            }}>
              <span>{member.displayName}</span>
              {!event.picked && (member.joined ?
                <span style={{
                  backgroundColor: '#109433',
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  Joined
                </span>
                :
                <span style={{
                  backgroundColor: '#C71212',
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  Pending
                </span>)}
            </li>
          ))}
        </ul>
        {(!event.picked && currentUser?.uid !== event.owner?.uid) && <Buttons_for_members_while_event_is_not_picked
          event={event}
          currentUserIndex={currentUserIndex} />
        }
        {(event.owner?.uid === currentUser?.uid && !event.picked) && <Secret_santa_button_display event={event} />}
        {event.owner?.uid === currentUser?.uid && <Delete_Button event={event} />}
        <h3>{event.picked && `Your Secret Santa: ${secret_santa_name}`}</h3>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px' }}>
      <h1>Welcome {currentUser?.displayName}!</h1>
      <h2>{(events.length > 0) ? 'Your events:' : 'No Current Events'}</h2>
      <ul>
        {events.map((event, index) => (
          <li key={index}>
            <Event_Display event={event} />
          </li>
        ))}
      </ul>
      <button
        onClick={() => navigate('/create')}
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: '#109433',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
          margin: '10px'
        }}
      >
        Create New Event
      </button>
      <button
        onClick={handleLogout}
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: '#109433',
          color: 'white',
          border: 'none',
          margin: '10px'
        }}
      >
        Log Out
      </button>
    </div>
  );
}